import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { localText } from 'langs/fa/data-grid';
import { isMobile } from 'react-device-detect';
import { useLocation, useParams } from 'react-router-dom';

//Contexts
import { store as mainStore } from 'store';

//Requests
import axios from 'api/axios';

//Hooks
import { useSearchParams } from 'hooks/useSearchParams';

//Components
import { store } from './Tendering';
import DataGrid from 'components/DataGrid/DataGrid';
import NoDrivers from './NoDrivers';
import User from 'components/User/UserAvatar';
import CallUser from 'components/User/CallUser';
import MarketingDialog from './MarketingDialog';
import DriverLocation from 'components/Dialog/DriverLocation';
import ProgressiveButton from 'components/Button/ProgressiveButton';
import DriversFilters from './DriversFilters';

//MUIs
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
  Button as MUIButton,
  CircularProgress,
  Button,
} from '@material-ui/core';
import moment from 'moment-jalaali';
import YesNo from 'components/Dialog/YesNo';

//Icons
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/Restore';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useQuery } from 'react-query';

const useStyles = makeStyles((theme) => ({
  stars: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  root: {
    '& .deleted span': {
      color: 'red',
      textDecoration: 'line-through',
    },
    display: 'flex',
    flexFlow: 'column wrap',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
    '& .checked': {
      background: '#c8e6c9',
    },
  },
  actions: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
    gridTemplateRows: '56px 80px',
    gridGap: theme.spacing(1),
  },
  searchBox: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));
const ListDrivers = () => {
  const classes = useStyles();
  var {
    state: { order, drivers, driversPage, driverInterests },
    dispatch,
    actions: { fetchingDrivers, fetchingBidders },
    asyncRefresh,
    refresh,
  } = useContext(store);

  const {
    state: {
      Props: { itemsCountPerPage },
    },
    showError,
    showMessage,
  } = useContext(mainStore);

  const [values, setValues] = useState({
    loading: true,
    marketingD: false,
  });
  const { loading, marketingD } = values;
  const [checked, setChecked] = useState([]);
  const [smsMarketingLoading, setSmsMarketingLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [params, setParams] = useSearchParams(null);
  const [loadingDeletingModal, setLoadingDeletingModal] = useState(false);
  const [loadingLastMarketing, setLoadingLastMarketing] = useState(false);
  const [loadingChoosingDriver, setLoadingChoosingDriver] = useState({
    id: null,
    loading: false,
  });
  const [totalPages, setTotalPages] = useState(null);
  const firstRender = useRef(true);

  const { id: orderId } = useParams();
  const location = useLocation();

  async function getDriverLogs(params) {
    // if (!drivers?.length || drivers?.length > 1) return;
    try {
      setLoadingLastMarketing({ loading: true, id: params.value?._id });
      //drivers[0]?._id
      const { data } = await axios.get(
        `api/v1/admin/orders/tendering/list/marketings/${orderId}/${params.value?._id}`
      );
      if (data.ok === true) {
        if (data?.logs.length === 0) {
          // showError('این راننده هنوز بازاریابی نشده است.');
          return;
        } else {
          const lastMarketing = data?.logs.slice(-1)[0];
          const driverIndex = driversData.docs.findIndex(
            (item) => item._id === params.value?._id
          );
          driversData.docs[driverIndex].marketingLog = {
            reason: lastMarketing.log.text,
            date: lastMarketing.createdAt,
            marketer:
              lastMarketing.creator.firstName +
              ' ' +
              lastMarketing.creator.lastName,
          };
          dispatch({
            type: 'DRIVERS_MARKETING_LOG',
            payload: {
              driverId: params.value?._id,
              marketingLog: {
                reason: lastMarketing.log.text,
                date: lastMarketing.createdAt,
                marketer:
                  lastMarketing.creator.firstName +
                  ' ' +
                  lastMarketing.creator.lastName,
              },
            },
          });
        }
      }
    } catch (error) {
      showError(error);
      console.error(error);
    } finally {
      setLoadingLastMarketing({ loading: false, id: null });
    }
  }

  const handlePageChange = async (page) => {
    setParams([{ name: 'page', value: page }]);
    dispatch({
      type: 'CHANGE_DRIVERS_PAGE',
      payload: params.get('page') * 1 || 1,
    });
  };
  const handleSelectDriver = (selection) => {
    // const rowIds = selection.row.id;
    setChecked(selection);
  };

  const handleChangeDI = (e) => {
    if (params.get('justProperFleets') === 'true') {
      setParams([{ name: 'justProperFleets', value: 'false' }]);
    }
    const { checked } = e.target;
    setParams([{ name: 'driverInterests', value: checked }]);
    dispatch({
      type: 'CHANGE_DRIVER_INTERESTS',
      payload: params.get('driverInterests'),
    });
  };
  const handleChangeProperFleet = (e) => {
    const { checked } = e.target;
    setParams([{ name: 'justProperFleets', value: checked }]);
    dispatch({
      type: 'CHANGE_PROPER_FLEET',
      payload: params.get('justProperFleets'),
    });
  };

  const handleShowMarketingD = (param, e) => {
    e.stopPropagation();
    setChecked([param.value?._id]);
    setValues({ ...values, marketingD: true });
  };
  const handleCloseMarketingD = (agree) => {
    setValues({ ...values, marketingD: false });
    if (agree === true) {
      refresh();
    }
  };

  const handleSendSMS = async (id) => {
    try {
      setLoadingChoosingDriver({ id: id, loading: true });
      const {
        data: { ok, messages },
        data,
      } = await axios.post(`/api/v1/admin/orders/tendering/add/tenderer`, {
        orderId: order._id,
        drivers: [id],
        sendWay: 'sms',
      });
      if (ok) {
        showMessage(messages);
      } else {
        showMessage(messages, 2);
      }
      const { data: drivers } = await refetch();
      const { data: bidders } = await refetchBidders();
      dispatch({ type: 'ORDER', payload: data.order });
      dispatch({ type: 'DRIVERS', payload: drivers });
      dispatch({ type: 'BIDDERS', payload: bidders });
    } catch (error) {
      showError(error);
    } finally {
      setLoadingChoosingDriver({ id: null, loading: false });
    }
  };
  const handleJustSendSMS = async (e) => {
    try {
      setSmsMarketingLoading(true);
      showMessage('در حال ارسال پیامک، لطفا تا اعلام نتیجه صبر کنید...');
      const {
        data: { ok, messages },
        data,
      } = await axios.post(`/api/v1/admin/orders/tendering/justSMS`, {
        orderId: order._id,
        drivers: checked,
        sendWay: 'sms',
      });
      if (ok) {
        showMessage(messages);
      } else {
        showMessage(messages, 2);
      }
      refetch();
      refetchBidders();
      dispatch({ type: 'ORDER', payload: data.order });
      dispatch({ type: 'DRIVERS', payload: drivers });
      dispatch({ type: 'BIDDERS', payload: bidders });
    } catch (error) {
      showError(error);
    } finally {
      setSmsMarketingLoading(false);
    }
  };
  // const handleSendNotification = async () => {
  //   try {
  //     const {
  //       data: { ok, messages },
  //       data,
  //     } = await axios.post(`/api/v1/admin/orders/tendering/justNotif`, {
  //       orderId: order._id,
  //       drivers: checked,
  //     });
  //     if (ok) {
  //       showMessage(messages);
  //     } else {
  //       showMessage(messages, 2);
  //     }
  //     dispatch({ type: 'ORDER', payload: data.order });
  //     const drivers = await fetchingDrivers(order._id);
  //     const bidders = await fetchingBidders(
  // order._id,
  // driversPage,
  // itemsCountPerPage
  //     );
  //     dispatch({ type: 'DRIVERS', payload: drivers });
  //     dispatch({ type: 'BIDDERS', payload: bidders });
  //   } catch (error) {
  //     showError(error);
  //   }
  // };
  const openDeleteDialog = (id) => {
    setOpenDialog(true);
    setDeletingId(id);
  };
  const handleCloseDialog = (agree) => {
    if (!agree) {
      setDeletingId(null);
      return setOpenDialog(false);
    }
    return handleDeleteUser();
  };
  const handleDeleteUser = async () => {
    try {
      setLoadingDeletingModal(true);
      const { data } = await axios.delete(`/api/v1/admin/users/${deletingId}`);
      if (data.ok) {
        setOpenDialog(false);
        showMessage(data.messages);
        refetch();
        refetchBidders();
        // setValues({ ...values, loading: true });
        // await asyncRefresh();
        // setValues({ ...values, loading: false });
      }
    } catch (error) {
      showError(error);
    } finally {
      setLoadingDeletingModal(false);
    }
  };
  const handleRestoreUser = async (userId) => {
    try {
      setLoadingDeletingModal(true);
      const { data } = await axios.post(
        `/api/v1/admin/users/restore/${userId}`
      );
      setLoadingDeletingModal(false);
      if (data?.ok) showMessage(data?.messages);
      setValues({ ...values, loading: true });
      await asyncRefresh();
      setValues({ ...values, loading: false });
    } catch (error) {
      showError(error);
    }
  };

  //"60b3bd6cf9fb1851d12372e3"
  //"60a0d7aa5fff1616fdade6ba"

  const columns = useMemo(
    () => [
      {
        field: 'name',
        sortable: false,
        headerName: 'نام',
        width: 350,
        renderCell: (params) => (
          <div
            style={{
              width: '15vw',
              overflow: 'hidden',
            }}
            className={`w-100 p-md-4 p-0 ${
              order.driversGetSmsRecivied.includes(params.value._id) &&
              ' bg-warning p-md-0 p-2'
            }`}
          >
            <div className="d-flex justify-content-between align-items-center">
              <User user={params.value.user} fullName />
              <MUIButton
                variant="outlined"
                color="secondary"
                size="small"
                style={{ maxHeight: '40px' }}
                className={'me-4 ' + classes.chooseDriverButton}
                onClick={() => handleSendSMS(params.value._id)}
                disabled={
                  loadingChoosingDriver.id === params.row?.id &&
                  loadingChoosingDriver.loading
                }
                endIcon={
                  loadingChoosingDriver.id === params.row?.id &&
                  loadingChoosingDriver.loading ? (
                    <CircularProgress size={'10px'} />
                  ) : undefined
                }
              >
                {isMobile ? 'انتخاب' : 'انتخاب راننده'}
              </MUIButton>
            </div>
          </div>
        ),
        cellClassName: ({ value }) => '',
      },
      {
        headerName: 'حذف کاربر',
        field: 'deleteUser',
        width: 125,
        sortable: false,
        renderCell: (params) => (
          <MUIButton
            startIcon={
              params.value?.user?.deleted ? <RestoreIcon /> : <DeleteIcon />
            }
            size={'small'}
            className={`h-75 mt-2 ${
              params.value.user?.isDeleted
                ? ' text-success'
                : params.value.user?.status === 'pending'
                ? ' pending '
                : 'text-danger'
            }`}
            variant="outlined"
            onClick={() => {
              if (params.value.user.isDeleted) {
                return handleRestoreUser(params.value?.user?._id);
              }
              return openDeleteDialog(params.value?.user?._id);
            }}
          >
            {params.value?.user?.isDeleted ? 'بازگردانی' : 'حذف'}
          </MUIButton>
        ),
        cellClassName: ({ value }) => '',
      },
      {
        field: 'TelMarketing',
        headerName: 'بازاریابی تلفنی',
        width: 150,
        renderCell: (params) => (
          <span>
            <MUIButton
              onClick={(e) => handleShowMarketingD(params, e)}
              variant={'contained'}
              color="secondary"
              size="small"
              className={
                order.driversGetNotified.includes(params.value._id)
                  ? ' checked text-black'
                  : ''
              }
            >
              بازاریابی تلفنی
            </MUIButton>
          </span>
        ),
        cellClassName: ({ value }) =>
          value.user?.isDeleted
            ? 'deleted ps-3'
            : value.user?.status === 'pending'
            ? 'pending ps-3'
            : 'ps-3',
      },
      {
        field: 'date',
        headerName: 'آخرین بازاریابی',
        headerAlign: 'center',
        width: 300,
        renderCell: (params) => (
          <span className="d-flex justify-content-md-center me-md-0 me-4">
            {params?.value?.marketingLog === undefined && (
              <span
                onMouseEnter={() => getDriverLogs(params)}
                onClick={() => isMobile && getDriverLogs(params)}
              >
                {loadingLastMarketing?.id !== params.value._id ? (
                  <span>
                    <HelpOutlineIcon
                      color="action"
                      style={{
                        width: '25px',
                        height: '25px',
                      }}
                    />
                  </span>
                ) : (
                  loadingLastMarketing.loading &&
                  params.value._id === loadingLastMarketing.id && (
                    <CircularProgress
                      className=" mt-4"
                      size={'25px'}
                      color="primary"
                    />
                  )
                )}
              </span>
            )}
            {params.value?.marketingLog !== undefined && (
              <div
                className="text-muted d-flex flex-wrap"
                style={{ lineHeight: '20px', fontSize: '12px' }}
              >
                <div>{params.value?.marketingLog.reason} </div>
                <div>بازاریاب : {params.value?.marketingLog.marketer} -</div>
                <span className="px-2">
                  {moment(params.value?.marketingLog.date).format(
                    'تاریخ: dd jMM/jDD س hh:mm'
                  )}
                </span>
              </div>
            )}
          </span>
        ),
        cellClassName: ({ value }) =>
          value.user?.isDeleted
            ? 'deleted px-2'
            : value.user?.status === 'pending'
            ? ' pending  d-flex justify-content-center'
            : ' d-flex justify-content-center',
      },
      {
        field: 'mobilePhone',
        headerName: 'موبایل',
        width: 120,
        renderCell: (params) => (
          <span>
            <CallUser tel={params.value?.user?.mobilePhone} />
          </span>
        ),
        cellClassName: ({ value }) =>
          value.user?.isDeleted
            ? 'deleted ps-3'
            : value.user?.status === 'pending'
            ? 'pending ps-3'
            : 'ps-3',
      },
      {
        field: 'fleetOptions',
        headerName: 'ناوگان',
        width: 120,
        renderCell: (params) => {
          return (
            <span>
              {params.value?.fleetOptions?.[0]?.fleet?.title +
                ' ' +
                params.value?.fleetOptions?.[0]?.title}
            </span>
          );
        },
        cellClassName: ({ value }) =>
          value.user?.isDeleted
            ? 'deleted ps-3'
            : value.user?.status === 'pending'
            ? 'pending ps-3'
            : 'ps-3',
      },
      {
        field: 'gps',
        headerName: '📍',
        width: 80,
        renderCell: (params) => (
          <span>
            <DriverLocation driver={params.value} />
          </span>
        ),
        cellClassName: ({ value }) =>
          value.user?.isDeleted
            ? 'deleted ps-3'
            : value.user?.status === 'pending'
            ? 'pending ps-3'
            : 'ps-3',
      },
    ],
    [
      drivers,
      loadingLastMarketing,
      loadingChoosingDriver.loading,
      params.get('page'),
      params.get('firstName'),
      params.get('mobilePhone'),
    ]
  );

  async function getDrivers(signal) {
    try {
      const drivers = await fetchingDrivers(order._id, signal);
      dispatch({ type: 'DRIVERS', payload: drivers });
      drivers.totalPages && setTotalPages(drivers.totalPages);
      return drivers;
    } catch (error) {
      showError(error);
      console.error(error);
      return error;
    }

    // try {
    //   const page = params.get('page') * 1 || 1;
    //   setValues({ ...values, loading: true });
    //   if (page) {
    //     if (order && order._id) {
    //       const drivers = await fetchingDrivers(order._id);
    // dispatch({ type: 'DRIVERS', payload: drivers });
    //       return drivers;
    //     }
    //   }

    // } catch (error) {
    //   showError(error);
    // } finally {
    // setValues({ ...values, loading: false });
    // }
  }

  const { data: driversData, isLoading, refetch } = useQuery(
    ['tenderingDriversList', location.search, itemsCountPerPage],
    ({ signal }) => getDrivers(signal),
    {
      // staleTime: 1 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );

  const { data: bidders, refetch: refetchBidders } = useQuery(
    ['bidders', order?._id, driversPage, itemsCountPerPage],
    ({ signal }) =>
      fetchingBidders(order?._id, driversPage, itemsCountPerPage, signal),
    {
      refetchOnWindowFocus: false,
      // staleTime: 1 * 60 * 60,
    }
  );

  return (
    <div className={classes.root}>
      <MarketingDialog
        open={marketingD}
        onClose={handleCloseMarketingD}
        drivers={checked}
      />
      <div className={classes.searchBox}>
        <DriversFilters />
      </div>
      <span>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                params.get('justProperFleets') === 'true'
                  ? false
                  : params.get('driverInterests') === null
                  ? true
                  : params.get('driverInterests') === 'true'
              }
              onChange={handleChangeDI}
            />
          }
          label="رانندگان آنلاین امروز"
        />
        <FormControlLabel
          className="me-md-4"
          control={
            <Checkbox
              checked={
                params.get('justProperFleets') === null
                  ? false
                  : params.get('justProperFleets') === 'true'
              }
              onChange={handleChangeProperFleet}
            />
          }
          label="نمایش سایر رانندگان"
        />
        <ProgressiveButton
          style={{
            // position: 'absolute',
            // right: '200px',
            // top: '10px',
            backgroundColor: '#ffff00',
            color: 'black',
            zIndex: '10',
          }}
          fullWidth
          className={'d-flex d-md-none mt-4'}
          loading={smsMarketingLoading ? true : false}
          endIcon
          variant="contained"
          disabled={checked?.length === 0 || smsMarketingLoading}
          onClick={handleJustSendSMS}
        >
          ارسال پیامک
        </ProgressiveButton>
      </span>
      <div
        style={{
          width: '100%',
          position: 'relative',
          height: isMobile ? 'initial' : 480,
        }}
      >
        <Button
          style={{
            position: 'absolute',
            right: '200px',
            top: '10px',
            backgroundColor: '#ffff00',
            color: 'black',
            zIndex: '10',
            border: 'none',
          }}
          className={'d-none d-md-flex'}
          loading={smsMarketingLoading ? true : false}
          endIcon={smsMarketingLoading && <CircularProgress size={10} />}
          variant="contained"
          disabled={checked?.length === 0 || smsMarketingLoading}
          onClick={handleJustSendSMS}
        >
          ارسال پیامک
        </Button>
        <DataGrid
          rows={
            driversData?.docs
              ? driversData.docs
                  ?.filter(
                    (driver) =>
                      !order.bidders.includes(driver._id) &&
                      driver?.user?.deleted !== true
                  )
                  .map((driver) => ({
                    id: driver._id,
                    name: driver,
                    TelMarketing: driver,
                    deleteUser: driver,
                    date: driver,
                    mobilePhone: driver,
                    fleetOptions: driver,
                    rank: driver,
                    gps: driver,
                  }))
              : []
          }
          columns={columns}
          localeText={localText}
          pageSize={Number(itemsCountPerPage)}
          rowCount={driversData?.totalDocs || 0}
          paginationMode="server"
          onPageChange={handlePageChange}
          loading={isLoading ? true : false}
          disableSelectionOnClick
          components={{
            NoRowsOverlay: NoDrivers,
          }}
          pageNumber={params.get('page') ? Number(params.get('page')) : 1}
          checkboxSelection={true}
          onCellClick={handleSelectDriver}
          hasSelectAll
          footerPagination={true}
          totalPages={totalPages}
          defaultPage={params.get('page') * 1 || 1}
        />
      </div>
      <YesNo
        loadingButton={true}
        inProgress={loadingDeletingModal}
        open={openDialog}
        onClose={handleCloseDialog}
        title=" آیا از حذف این کاربر مطمئن هستید؟"
      />
    </div>
  );
};

export default React.memo(ListDrivers);
